// frontend/src/utils/authLink.js
// Builds a URL for browser navigation (new tab / iframe) where we can't set headers.
// We append the bearer token AND a tenant hint so the backend can resolve the tenant.

function readJwtPayload(token) {
  try {
    const base64 = token.split('.')[1];
    if (!base64) return {};
    // handle base64url
    const norm = base64.replace(/-/g, '+').replace(/_/g, '/');
    const json = atob(norm);
    return JSON.parse(json);
  } catch {
    return {};
  }
}

export function authorizedUrl(path) {
  const token =
    localStorage.getItem('token') ||
    sessionStorage.getItem('token') ||
    '';

  // Try to find tenant id from JWT first, then from storage as fallback
  let tenantId = '';
  const payload = token ? readJwtPayload(token) : {};
  tenantId =
    payload.tenant_id ||
    payload.tenant ||
    localStorage.getItem('tenant_id') ||
    sessionStorage.getItem('tenant_id') ||
    '';

  const url = new URL(path, window.location.origin);
  if (token) url.searchParams.set('token', token);

  // Add multiple keys to maximize compatibility with your tenant resolver
  if (tenantId) {
    url.searchParams.set('tenant_id', tenantId);
    url.searchParams.set('tenant', tenantId);
    url.searchParams.set('t', tenantId);
  }

  return url.toString();
}
